import { FormalizedZipControllerService } from 'shared/api/generatedApi/services/FormalizedZipControllerService';
import { FormalizedZipRequestDto, FormalizedZipFilterRequest } from 'shared/api';

export const formalizedZipApi = {
  getFormalizedZips: () => FormalizedZipControllerService.filterFormalizedZips({}),
  getFormalizedZipById: (id: number) => FormalizedZipControllerService.findById(id),
  createFormalizedZip: (data: FormalizedZipRequestDto) => FormalizedZipControllerService.create(data),
  updateFormalizedZip: (id: number, data: FormalizedZipRequestDto) => FormalizedZipControllerService.update(id, data),
  deleteFormalizedZip: (id: number) => FormalizedZipControllerService.delete(id),
  filterFormalizedZips: (data: FormalizedZipFilterRequest) => FormalizedZipControllerService.filterFormalizedZips(data),
};
